export default "__VITE_ASSET__DhIYoNu4__"